import { ReactElement } from 'react'
import { cn } from '../../utils'

type TagProps = {
	label?: string
	value?: number | string
	variant?: 'primary' | 'secondary' | 'tertiary'
	size?: 'sm' | 'lg'
	icon?: ReactElement
	iconFirst?: boolean
	className?: string
}

export function Tag({
	label,
	value,
	variant,
	size,
	icon,
	iconFirst = false,
	className,
}: TagProps) {
	const base = 'w-fit rounded'
	const sizes = {
		sm: 'py-1 px-3 text-sm',
		lg: 'py-1.5 px-3',
	}
	const variants = {
		primary: 'bg-background text-foreground',
		secondary: 'bg-primary text-primary-foreground',
		tertiary: 'bg-foreground text-background',
	}
	return (
		<div
			className={cn(
				base,
				sizes[size || 'sm'],
				variants[variant || 'primary'],
				className,
			)}
		>
			{icon && !iconFirst && icon}
			{label}
			{value && <span className="ml-1">{value}</span>}
			{icon && !iconFirst && icon}
		</div>
	)
}
